module.exports = __webpack_public_path__ + "img/EASTEA_LOGO.1b818507.jpeg";